// extracted by mini-css-extract-plugin
export default {"table":"table_table__uYOqS","geolink":"table_geolink__h17W9"};